/**
 * @generated SignedSource<<76e81bcfb47e3edfc5ce66be70e1b716>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EditPersonalizedNotificationTemplateInput = {
  clientMutationId?: string | null;
  id: string;
  message: string;
  title: string;
};
export type personalizedNotificationTemplateEdit_EditPersonalizedNotificationTemplateMutation$variables = {
  input: EditPersonalizedNotificationTemplateInput;
};
export type personalizedNotificationTemplateEdit_EditPersonalizedNotificationTemplateMutation$data = {
  readonly Admin: {
    readonly Notification: {
      readonly editPersonalizedNotificationTemplate: {
        readonly edge: {
          readonly node: {
            readonly " $fragmentSpreads": FragmentRefs<"personalizedNotificationTemplateEdit_PersonalizedNotificationTemplateFragment">;
          };
        };
      } | null;
    };
  };
};
export type personalizedNotificationTemplateEdit_EditPersonalizedNotificationTemplateMutation = {
  response: personalizedNotificationTemplateEdit_EditPersonalizedNotificationTemplateMutation$data;
  variables: personalizedNotificationTemplateEdit_EditPersonalizedNotificationTemplateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "personalizedNotificationTemplateEdit_EditPersonalizedNotificationTemplateMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NotificationAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Notification",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "EditPersonalizedNotificationTemplatePayload",
                "kind": "LinkedField",
                "name": "editPersonalizedNotificationTemplate",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PersonalizedNotificationTemplatesEdge",
                    "kind": "LinkedField",
                    "name": "edge",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PersonalizedNotificationTemplate",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "personalizedNotificationTemplateEdit_PersonalizedNotificationTemplateFragment"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "personalizedNotificationTemplateEdit_EditPersonalizedNotificationTemplateMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NotificationAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Notification",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "EditPersonalizedNotificationTemplatePayload",
                "kind": "LinkedField",
                "name": "editPersonalizedNotificationTemplate",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PersonalizedNotificationTemplatesEdge",
                    "kind": "LinkedField",
                    "name": "edge",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PersonalizedNotificationTemplate",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "NotificationTemplate",
                            "kind": "LinkedField",
                            "name": "template",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "key",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "title",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "message",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "variables",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c6fd38b1615d1ebf61b66aef876e7c13",
    "id": null,
    "metadata": {},
    "name": "personalizedNotificationTemplateEdit_EditPersonalizedNotificationTemplateMutation",
    "operationKind": "mutation",
    "text": "mutation personalizedNotificationTemplateEdit_EditPersonalizedNotificationTemplateMutation(\n  $input: EditPersonalizedNotificationTemplateInput!\n) {\n  Admin {\n    Notification {\n      editPersonalizedNotificationTemplate(input: $input) {\n        edge {\n          node {\n            ...personalizedNotificationTemplateEdit_PersonalizedNotificationTemplateFragment\n            id\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment personalizedNotificationTemplateEdit_PersonalizedNotificationTemplateFragment on PersonalizedNotificationTemplate {\n  id\n  template {\n    key\n    title\n    message\n    variables\n  }\n}\n"
  }
};
})();

(node as any).hash = "4d84c90877280d84e33c2ac3ae9968d3";

export default node;
